import mapboxgl from "mapbox-gl";

import defaultStyles from "fond/draw/defaultStyles";
import { MapboxStyleLayer } from "fond/types";

/**
 * The MapboxDraw theme extended to include styles specific to planner projects
 * when drawing aerial features.
 */
const modifiedDefaults: MapboxStyleLayer[] = defaultStyles.map((style) => {
  if (style.id === "gl-draw-point-stroke-active") {
    return {
      ...style,
      paint: {
        ...style.paint,
        "circle-radius": 10,
        "circle-color": "#FFF000",
      },
    } as mapboxgl.CircleLayer;
  }
  // Override the line styles to include hover effects
  if (style.id === "gl-draw-line-inactive") {
    return {
      ...style,
      paint: {
        ...style.paint,
        "line-color": ["case", ["==", ["get", "user_meta:hover"], "true"], "#1489EF", "#3fffff"],
      },
    } as mapboxgl.LineLayer;
  }

  if (style.id === "gl-draw-line-active") {
    return {
      ...style,
      paint: {
        ...style.paint,
        "line-dasharray": [1],
        "line-width": 3,
        "line-color": "#FF5832",
      },
    } as mapboxgl.LineLayer;
  }

  if (["gl-draw-point-active", "gl-draw-point-inactive"].includes(style.id)) {
    return {
      ...style,
      type: "symbol",
      layout: {
        "text-field": "\uE828",
        "text-anchor": "bottom",
        "text-justify": "center",
        "text-allow-overlap": true,
        "text-ignore-placement": true,
        "text-font": ["fontello Regular"],
        "text-padding": 0,
        "text-rotate": 0.01,
        "text-size": ["interpolate", ["linear"], ["zoom"], 10, 0, 18, 22],
        "text-line-height": -0.45,
      },
      paint: {
        "text-color": ["case", ["==", ["get", "user_meta:unsnapped"], "true"], "red", "black"],
        "text-opacity": 1,
        "text-translate": [-0.6, 0.1],
        "text-halo-width": ["interpolate", ["linear"], ["zoom"], 10, 0, 18, 2],
        "text-halo-color": "#ffffff",
      },
    } as mapboxgl.SymbolLayer;
  }

  // Override the color of the vertex & mid point colors
  if (
    ["gl-draw-polygon-midpoint", "gl-draw-polygon-and-line-vertex-inactive", "gl-draw-polygon-and-line-vertex-stroke-inactive"].includes(style.id)
  ) {
    return {
      ...style,
      paint: {
        ...style.paint,
        "circle-color": "#FF5832",
      },
    } as mapboxgl.CircleLayer;
  }

  return style;
});

const styles: MapboxStyleLayer[] = [
  ...modifiedDefaults,
  // Add a custom hover style
  {
    id: "gl-draw-point-hover-active",
    type: "circle",
    filter: ["all", ["==", "$type", "Point"], ["==", "meta", "feature"], ["!=", "mode", "static"]],
    paint: {
      "circle-color": "#BBD5ED",
      "circle-radius": ["interpolate", ["linear"], ["zoom"], 10, 0, 18, 5],
      "circle-opacity": ["case", ["==", ["get", "user_meta:hover"], "true"], 1, 0],
      "circle-stroke-width": ["case", ["==", ["get", "user_meta:hover"], "true"], 2, 0],
      "circle-stroke-color": "#8BA2B7",
    },
  },
];

export default styles;
